import { TableTitle } from '@lmt/unicorn-shared/app/components/common/table/TableTitle';
import { PatientExtendedSearch } from '@lmt/unicorn-shared/app/components/patients/search/PatientExtendedSearch';
import { ExtendedSearchPageHeader } from '@lmt/unicorn-shared/app/components/search/ExtendedSearchPageHeader';
import { useQueryParamsInTab } from '@lmt/unicorn-shared/app/helpers/use-query-params-in-tab';
import React, { useMemo, useState } from 'react';
import { StringParam, withDefault } from 'react-router-url-params';
import { Button, ButtonColor } from '../common/ui-kit/buttons/Button';
import { useGlobalForms } from '../global-forms/useGlobalForms';
import { useTranslation } from 'react-i18next';
import { MergeContext, MergePair } from './types';
import { useClaims } from '@lmt/unicorn-shared/app/features/auth/operations';

import styles from './ExtendedSearchPage.module.scss';
import MergeIcon from '@lmt/unicorn-shared/app/icons/merge.svg?react';
import { splitTagString } from '../common/ui-kit/tags/tags-helpers';
import clsx from 'clsx';
const ExtendedSearchPage: React.FC = () => {
  const forms = useGlobalForms();
  const claims = useClaims();
  const i18next = useTranslation();
  const [isMergeEnabled, setMergeEnabled] = useState<boolean>(false);
  const [mergePair, setMergePair] = useState<MergePair | null>(null);
  const [queryParams, setQueryParams] = useQueryParamsInTab({
    search: withDefault(StringParam, ''),
  });

  const searchStringWithTags = useMemo(() => {
    return splitTagString(queryParams.search);
  }, [queryParams.search]);
  return (
    <div
      className={styles.extendedSearchContainer}
      data-test-id="table-page-container"
    >
      <TableTitle
        title={searchStringWithTags.map((x, i) => {
          return (
            <span key={i} className={clsx(x.isTag && styles.tag)}>
              {x.text}
            </span>
          );
        })}
        className={styles.tableTitle}
      />
      <ExtendedSearchPageHeader>
        {claims.permissions.mergePatients && isMergeEnabled && (
          <Button
            disabled={!mergePair}
            iconComponent={<MergeIcon />}
            title={i18next.t('merge_assistant.merge_button')}
            color={ButtonColor.Primary}
            className={styles.mergeButton}
            onClick={() => {
              forms.openMergePair(
                mergePair!.firstPatientId,
                mergePair!.secondPatientId,
              );
              setMergePair(null);
            }}
          />
        )}
      </ExtendedSearchPageHeader>
      <MergeContext.Provider
        value={{
          isMergeEnabled,
          isSelectable: true,
          setMergePair,
          setMergeEnabled,
        }}
      >
        <PatientExtendedSearch searchString={queryParams.search} />
      </MergeContext.Provider>
    </div>
  );
};

export default ExtendedSearchPage;
